import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CorrelationObserverService } from './correlation-observer.service';
import { ActionCache } from './action-cache';
import { environment } from '../../../../../../apps/light-range/src/environments/environment';
import { DataPersistence} from "./data-persistence.service";

@NgModule({
  imports: [CommonModule],
  providers: [
    CorrelationObserverService,
    DataPersistence,
    {
      provide: ActionCache,
      useValue: new ActionCache({ ttl: 60 * 1000, logEnabled: !environment.production}),
    }
  ]
})
export class NgrxHelperModule {
}
